<template>
  <div>
    <div style="width: 100%;">
      <div id="itemschart">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    list11: Array,
  },
  name: "",
  data () {
    return {

    }
  },
  created () {
   
  },
  mounted () {
    this.line()
  },
  methods: {
    line () {
      let chartDom = document.getElementById('itemschart');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#73c0de',
          '#3ba272',
          '#fc8452',
          '#1cbfd7',
          '#00b2de',],
        legend: {},
        tooltip: {},
        dataset: {
          source: this.list11
        },
        xAxis: { type: 'category' },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series:[{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
    }
  },
  watch: {
    list11: {
      deep: true,
      handler (val) {
        this.line()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped>
#itemschart {
  height: 400px;
}
</style>




// WEBPACK FOOTER //
// src/statistics/components/itemschart.vue